"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var BemBuilder_1 = __importDefault(require("@CommonFrontend/Utils/BemBuilder"));
var FormatCurrency_1 = require("@CommonFrontend/Utils/FormatCurrency");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var c = (0, BemBuilder_1.default)("chart-custom__tooltip");
function BarTooltipPageValueBottom(props) {
    var tooltipPayload = props.tooltipPayload, xAxisName = props.xAxisName, opts = props.opts;
    var _a = __read(tooltipPayload, 1), value = _a[0].value;
    if (!opts)
        return null;
    var _b = opts.avgPageValue, avgPageValue = _b === void 0 ? {} : _b, currency = opts.currency;
    var avgStatusPageValue = avgPageValue[xAxisName.toLowerCase()].total || 0;
    return (react_1.default.createElement("div", { className: c() },
        react_1.default.createElement(kaleidoscope_1.Label, { align: "center", theme: "dark", className: c("header") },
            "old ",
            xAxisName,
            " pages value"),
        react_1.default.createElement(kaleidoscope_1.Text, { size: "xs", align: "center", theme: "dark", strong: true }, (0, FormatCurrency_1.formatAbbreviatedCurrency)(value, currency, 1, true)),
        react_1.default.createElement(kaleidoscope_1.Text, { size: "xs", align: "center", theme: "dark" },
            "The total value of ",
            xAxisName.toLowerCase(),
            " pages ",
            react_1.default.createElement("span", { className: "italic" }, "before"),
            " the selected period."),
        react_1.default.createElement("div", { className: c("divider") }),
        react_1.default.createElement("div", { className: c("avg-time-info") },
            react_1.default.createElement("div", { className: c("avg-time-info", "left") },
                react_1.default.createElement(icons_1.Clock, { className: c("avg-time-info__icon"), size: icons_1.IconSize.Medium }),
                react_1.default.createElement(kaleidoscope_1.Label, { theme: "dark", size: "s", secondary: true }, "Av. PAGE VALUE")),
            react_1.default.createElement(kaleidoscope_1.Text, { theme: "dark", size: "xs", strong: true }, (0, FormatCurrency_1.formatAbbreviatedCurrency)(avgStatusPageValue, opts.currency, 1, true)))));
}
exports.default = BarTooltipPageValueBottom;
